var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customCategory"},[_c('van-tabs',{attrs:{"color":"#FF5733","sticky":"","title-active-color":"#FF5733"},on:{"change":_vm.tabChangeFn},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.list),function(item){return _c('van-tab',{key:item.id,attrs:{"title":item.name}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }